import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
export const legalLinksQueryKey = ['og', 'legal-links'];
export function useLegalLinks(enabled = true) {
    return useQuery({
        queryKey: legalLinksQueryKey,
        queryFn: () => apiOg('users', '/api/v1/admin/legal-links'),
        enabled,
        retry: false,
    });
}
export function useUpdateLegalLinks() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ locale, body }) => apiOg('users', `/api/v1/admin/legal-links/${locale}`, {
            method: 'PUT',
            body,
        }),
        onSuccess: (saved) => {
            queryClient.setQueryData(legalLinksQueryKey, (current) => {
                if (!current)
                    return [saved];
                return current.map((row) => (row.locale === saved.locale ? saved : row));
            });
        },
    });
}
